import { PostApiCall } from "./axiosSetup";

export const DEPOSIT = '/payment/deposit';

export const Deposit = async (data) => PostApiCall(DEPOSIT, data, "https://api.goatspins.com");